import React from 'react';
import { Box, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { ReactComponent as AgendaIcon } from 'src/icons/agenda.svg';
import palette from 'src/theme/palette';

import { SplitsInputWrapper } from '../styled';
import { InputName, MetricsInputProps } from '../types';

import { Badge } from './Badge';

export const MetricsInput = ({
  metricsIsShown,
  closeMetrics,
  showMetrics,
}: MetricsInputProps) => {
  const { watch } = useFormContext();

  const handleInputClick = () => {
    if (metricsIsShown) {
      closeMetrics();
    } else {
      showMetrics();
    }
  };
  // test
  return (
    <SplitsInputWrapper onClick={handleInputClick}>
      <Box display="flex" gap="5px" alignItems="center">
        <AgendaIcon
          color={metricsIsShown ? palette.primary.main : palette.grey[800]}
        />
        <Typography fontSize="16px" lineHeight="21px" fontWeight={600}>
          Metrics
        </Typography>
        <Badge
          sx={{
            backgroundColor: metricsIsShown
              ? palette.primary.light
              : palette.grey[100],
          }}
          badgeContent={watch(InputName.metrics).length}
        />
      </Box>
    </SplitsInputWrapper>
  );
};
